const styles = (theme) => ({
    title: {
        fontWeight: '500',
        marginBottom: '10px',
    },
    yellowTitle: {
        fontWeight: '500',
        marginBottom: '10px',
        color: '#FEAD3D',
        fontSize: '1rem',
    },
    greenTitle: {
        fontWeight: '500',
        marginBottom: '10px',
        color: '#51Ac3B',
        fontSize: '1rem',
    },
    containerMainData: {
        marginTop: '30px',
    },
    loading: {
        marginTop: '25px',
    },
    table: {
        margin: '0 0 30px 0',
        backgroundColor: '#fff',
    },
    tableError: {
        borderCollapse: 'initial',
        margin: '0 0 30px 0',
        border: '2px solid #b71c1c',
        backgroundColor: '#fff',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    addButton: {
        borderRadius: '30px',
        padding: '5px 20px',
        border: '1px solid #ccc',
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: '#fff',
        alignItems: 'center',
        display: 'flex',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontFamily: theme.typography.fontFamily,
        float: 'right',
    },
    btnSigleAction: {
        minWidth: '30px',
        height: '30px',
        lineHeight: '30px',
        borderRadius: '50%',
        display: 'inline-flex',
        color: '#fff',
        marginRight: '5px',
        padding: '0',
        fontSize: '16px',
    },
    btnSignature: {
        color: '#6F6Fa9',
        '& img': {
            marginRight: '5px',
        },
    },
    centerProgress: {
        textAlign: 'center',
    },
    positionRelative: {
        position: 'relative',
    },
    circularProgress: {
        position: 'absolute',
        top: '23px',
        right: '40px',
    },
});

export default styles;
